import S from 'constants/string.const';
import { BeTimeoutError } from 'errors/be.error';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';

const L = logger('UMSG-BL'); // eslint-disable-line no-unused-vars

const coalesce = ($) => $.replace(/\n\s(?!\n)/g, S.space);

export const umsgCancelPayment = (options) => {
  const intentId = fromAnyToTrimmed(options?.intentId) || '(the id is missing)';

  // SEE: https://getslick.atlassian.net/browse/GS-13312
  // SEE: https://getslick.slack.com/archives/C7XSD44GN/p1711616854473339?thread_ts=1711615891.754819&cid=C7XSD44GN
  return coalesce(`
  Your client’s card was authorised but NO PAYMENT HAS BEEN TAKEN. 
  In order to complete the transaction, please restart the checkout process and ask your client to tap their card again.


  If you continue to see this message, please contact customer support and provide this payment id: ${intentId}.
  `);
};

export const umsgKpiPerformance = (options, context) => {
  if (context?.error instanceof BeTimeoutError) {
    return `
  it looks like there’s too much data to load your KPIs over this time period. 
  Please select a shorter time period such as 3 months.
`;
  }
};
